import './userProfile.css';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import { ClipLoader } from 'react-spinners';
import GameHeader from '../header/header';

const ResetPassword = () => {

    const [userData, setItems] = useState([]);
    const apiService = new ApiService();
    const [loader, setLoader] = useState(null);
    const [passwordForm, setPasswordForm] = useState({
        password: '',
        confirmPassword: ''
    });

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            fetchuserData(items)
        }
    }, []);
    const fetchuserData = async (items) => {
        try {
            const params = new URLSearchParams();
            params.append('id', items?.nameid);
            const res = await apiService.getApiParamater('GET_GAME_USER', `?${params.toString()}`);
            setItems(res?.data[0]);
        } catch (error) {
            console.error("Error fetching Currency data:", error);
        }
    }
    const handlePaswordChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        setPasswordForm(prev => ({
            ...prev,
            [name]: newValue
        }));
    };
    const handleResetPasswordsave = async () => {
        setLoader(true)
        if (!passwordForm?.password) {
            setLoader(false)
            toast.warning("Enter Password")
            return;
        } else if (passwordForm?.password != passwordForm?.confirmPassword) {
            setLoader(false)
            toast.warning("Both password must be same")
            return;
        }

        const payload = {
            userId: userData?.id,
            newPassword: passwordForm?.password
        };
        try {
            const response = await apiService.post('RESET_PASSWORD', payload);
            if (response?.status === 200) {
                setPasswordForm({
                    password: '', // default
                    confirmPassword: ''
                });
                setLoader(false)
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error reset:", error);
        }
    };
    return (
        <div className="obtibg">
            <GameHeader />
            <div className="profile-container">
                <div className="profile-card">
                    <div className="form-group">
                        <label>Password</label>
                        <input type="text" className="form-control" name="password"
                            onChange={handlePaswordChange} value={passwordForm?.password || ''} />
                        <label className='my-3'>Confirm Password</label>
                        <input
                            type="text"
                            className="form-control"
                            name="confirmPassword"
                            value={passwordForm.confirmPassword}
                            onChange={handlePaswordChange}
                        />
                        <div className='d-flex center mt-3'>
                            {loader === true ?
                                <Button variant="primary" className="w-50">
                                    <ClipLoader color='#fff' />
                                </Button>
                                :
                                <Button variant="primary" className="w-50" onClick={handleResetPasswordsave}>
                                    Save
                                </Button>
                            }


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
